import { FormWireItem, SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { DefaultContainerProps } from 'app/infrastructure/redux/types';
import { PromptProps } from 'app/components/prompt-unsaved/prompt-unsaved';
import { actionCreators } from './actions';
import { OptionsProps } from 'app/components/options-handler';
import { AdministrationRoleEditState } from 'app/area/administration/edit/role/types-store';
import { Value } from 'app/types-shared';
import { DefaultRole } from 'app/area/administration/shared/types';
import { AdministrationEditTranslation } from 'app/area/administration/edit/constants';

export interface AdministrationRoleEditStateExternalProps {
  id: number;
  editMode: boolean;
  shouldDisplayModal: boolean;
  optionsFetching: boolean;
  section: string;
}

export type AdministrationRoleEditProps = AdministrationRoleEditState & AdministrationRoleEditStateExternalProps &
  SimpleFormProps & DefaultContainerProps & PromptProps & typeof actionCreators & OptionsProps & RoleDataFactoryProps;

export enum RoleEditSectionType {
  Details = 'details',
  AccessToOperation = 'accessToOperation',
  AccessToScreen = 'accessToScreen',
  ExtendedAccess = 'extendedAccess',
  RestrictedAccess = 'restrictedAccess',
  AccessToAdministrateUserGroup = 'accessToAdministrateUserGroup',
  AccessToAssignRoles = 'accessToAssignRoles',
  DefaultValues = 'defaultValues',
  UserOccurence = 'userOccurence',
  Notifications = 'notifications'
}

export interface RoleDataFactoryProps {
  title: string;
  saveButtonText: string;
  showEditMenu?: boolean;
  showRoleId?: boolean;
  hideTopPanel?: boolean;
  duplicateUrl?: string;
  onLoadRole?: () => void;
  onSave: (setDefaultRoleData: SetDefaultRole) => void;
}

export interface SetDefaultRole {

  currentDefaultRole: DefaultRole;

  markedAsDefaultRole: boolean;

  roleId: number;

  translation: AdministrationEditTranslation;
}

export type QueryParam = { [key: string]: FormWireItem | Value[] };
